import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { FormOfPaymentTypeReferenceModel, FormOfPaymentTypeSearch, FormOfPaymentTypeSort, FormOfPaymentTypeUpdateSortSequence } from "../../models/form-of-payment-model";
import { FormOfPaymentTypeReferenceCommandModel } from "../../models/form-of-payment-model/form-of-payment-type-reference-command.model";

@Injectable({
    providedIn: 'root'
})
export class FormOfPaymentTypeReferenceService extends ApiServiceBase {
    private readonly PATH = '/system/FormOfPaymentTypeReferences';
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }
    public getAll(): Observable<FormOfPaymentTypeReferenceModel[]> {
        return this.httpGet<FormOfPaymentTypeReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
    public getSalesFOPTypeByOrganisation(): Observable<FormOfPaymentTypeReferenceModel[]> {
        return this.httpGet<FormOfPaymentTypeReferenceModel[]>(this.PATH + '/organisation/sales', null)
            .pipe(
                map(res => res.body)
            )
    }
    public getTopUpFOPTypeByOrganisation(): Observable<FormOfPaymentTypeReferenceModel[]> {
        return this.httpGet<FormOfPaymentTypeReferenceModel[]>(this.PATH + '/organisation/topup', null)
            .pipe(
                map(res => res.body)
            )
    }

    public updateStatusCode(formOfPaymentTypeCode: string, statusCode: string): Observable<never> {
        return this.httpPut<never>(this.PATH + '/updatestatus/' + formOfPaymentTypeCode + '/' + statusCode, null )
            .pipe(
                map(res => res.body)
            )
    }

    public search(statusCode?: string, formOfPaymentTypeNameWildcard?: string, formOfPaymentTypeCode?: string): Observable<FormOfPaymentTypeSearch[]> {
        const queryParams = new HttpParams({ fromObject: <any>{ statusCode, formOfPaymentTypeNameWildcard, formOfPaymentTypeCode } })
        return this.httpGet<FormOfPaymentTypeSearch[]>(`${this.PATH}/search`, queryParams)
            .pipe(
                map(res => res.body)
            )
    }

    public get(formOfPaymentTypeCode: string): Observable<FormOfPaymentTypeReferenceModel> {
        return this.httpGet<FormOfPaymentTypeReferenceModel>(this.PATH + "/code/" + formOfPaymentTypeCode, null)
            .pipe(
                map(res => res.body)
            )
    }

    public getLongCode(formOfPaymentTypeLongCode: string, formOfPaymentTypeCode: string): Observable<FormOfPaymentTypeReferenceModel[]> {
        return this.httpGet<FormOfPaymentTypeReferenceModel[]>(this.PATH + "/longcode/" + formOfPaymentTypeLongCode + '/code/' + formOfPaymentTypeCode, null)
            .pipe(
                map(res => res.body)
            )
    }
    
    public add(command: FormOfPaymentTypeReferenceCommandModel): Observable<FormOfPaymentTypeReferenceModel> {
        return this.httpPost<FormOfPaymentTypeReferenceModel>(this.PATH, command)
            .pipe(
                map(res => res.body)
            )
    }

    public edit(command: FormOfPaymentTypeReferenceCommandModel): Observable<FormOfPaymentTypeReferenceModel> {
        return this.httpPut<FormOfPaymentTypeReferenceModel>(this.PATH, command)
            .pipe(
                map(res => res.body)
            )
    }
    
    public getSort(): Observable<FormOfPaymentTypeSort[]> {
        return this.httpGet<FormOfPaymentTypeSort[]>(this.PATH + "/sort", null)
            .pipe(
                map(res => res.body)
            )
    }
    
    public updateSortSequence(items: FormOfPaymentTypeUpdateSortSequence[]): Observable<never> {
        return this.httpPut<never>(this.PATH + "/sort", items)
            .pipe(
                map(res => res.body)
            )
    }
}